import * as React from 'react';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { ButtonTertiary } from 'ui';

import styles from './paginator.scss';

interface PaginatorProps {
  first: () => void;
  previous: () => void;
  next: () => void;
  last: () => void;
  textPageOf?: string;
  currentPage: number;
  numberOfPages: number;
}

export function Paginator({
  first,
  previous,
  next,
  last,
  textPageOf,
  currentPage,
  numberOfPages
}: PaginatorProps) {
  const firstPageLink = <ButtonTertiary disabled={currentPage <= 1} onClick={first}>{'<<'}</ButtonTertiary>;
  const previousPageLink = <ButtonTertiary disabled={currentPage <= 1} onClick={previous}>{'<'}</ButtonTertiary>;
  const nextPageLink = <ButtonTertiary disabled={currentPage >= numberOfPages} onClick={next}>{'>'}</ButtonTertiary>;
  const lastPageLink = <ButtonTertiary disabled={currentPage >= numberOfPages} onClick={last}>{'>>'}</ButtonTertiary>;

  return (
    <div className={styles.paginator}>
      <div className={styles.previous}>
        {firstPageLink}
        {previousPageLink}
      </div>

      <div className={styles.currentPage}>
        <span>
          {replaceTemplateString(textPageOf, currentPage, numberOfPages)}
        </span>
      </div>

      <div className={styles.next}>
        {nextPageLink}
        {lastPageLink}
      </div>
    </div>
  );
}
